const forms: NodeListOf<HTMLElement> = document.querySelectorAll("#CountrySelectorBurger, #CountrySelectorAnnouncement");
forms.forEach((form) => {
  const select: HTMLSelectElement | null = form.querySelector("select");
  const input: HTMLInputElement | null = form.querySelector("input[name='country_code']");

  if (form && select && input) {
    select.addEventListener("change", function () {
      input.value = select.value;
      (form as HTMLFormElement).submit();
    });
  }
});